// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__tRE6e","navigation":"Sidebar_navigation__EZ9uS","logout":"Sidebar_logout__PkSIq"};